// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSharedExternalIdUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSharedExternalIdUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSharedExternalIdUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorSharedExternalIdUpsearchModel.additionalProperties = false;
EnterpriseCoordinatorSharedExternalIdUpsearchModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "ExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=enterpriseCoordinatorSharedExternalIdUpsearchModel.js.map